import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone';

import { Button, PopOut, Spinner } from 'components';
import { FaAngleDown } from 'react-icons/fa';
import OptionBlock from './OptionBlock';
import Options from './Options';

import { genAuthURL } from 'utils'

const Container = styled.div`
    background-color: var(--primary-color);
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    /* border: 1px solid var(--primary-accent-color); */
    cursor: pointer;
    margin: 0.5rem 0 0 0;
    border-style: solid;
    border-width: 2px;
    border-color: ${props => props.error ? 'var(--error-color)' : 'transparent'};
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Wrapper = styled.div`
    width: 100%;
    padding: 0.25rem 0.5rem;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 0.5rem;
    align-items: center;
    box-sizing: border-box;
`

const Label = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
`

const Column = styled.div`
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`

const Row = styled.div`
    display: flex;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
    margin-left: 0.2rem;
    :before {
        content: '*'
    }
`

const Placeholder = styled.div`

`

const Title = styled.div`
    min-height: 1.5rem;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
`

const AccountSelector = props => {
    const {
        value,
        selectedClient,
        onSelect,
        onError,
        styles,
        error
    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const timezone = user['timezone']
    const clients = useSelector((state) => state.integration.clients);

    const [showSpinner, setSpinner] = useState(false)
    const [open, setOpen] = useState(false)
    const [width, setWidth] = useState(styles && styles['width'])
    const ref = React.createRef()
    useEffect(() => {
        setWidth(ref.current.getBoundingClientRect()['width']+5)
    }, [])

    const getOptions = () => {
        let blocks = [];

        // Get existing accounts
        clients && Object.values(clients).map(client => {
            if(client['client'] === 'TRELLO' && client['clientId'] === 'placeholder'){ return }
            const subtitle = `Added ${moment(client['created']).tz(timezone).format('MMM D Y')}`
            client['client'] === selectedClient && blocks.push(<OptionBlock title={client['clientTitle']} subtitle={subtitle} onSelect={() => onSelect({clientId: client['clientId'], clientTitle: client['clientTitle']})}/>)
        })

        // Placeholder if no accounts
        blocks.length === 0 && blocks.push(<Placeholder>No accounts added</Placeholder>)

        // Add account option
        const buttonStyles = {
            backgroundColor: 'var(--secondary-color)',
            margin: '0.5rem 0 0 0',
            fontWeight: 'bolder'
        }
        blocks.push( 
            <Button text={showSpinner ? <Spinner styles={{color: 'var(--focus-color)'}}/> : 'Connect a new account'} 
                styles={buttonStyles} onSelect={openAuthURL}/>
        )

        return <Options width={width} blocks={blocks}/>
    }

    const openAuthURL = async () => {
        setSpinner(true)
        await genAuthURL(selectedClient, user['uid'])
        .then(res => {
            setSpinner(false)
            !res['success'] && onError('Something went wrong')
        })
        .catch(err => {
            setSpinner(false)
            onError('Something went wrong')
        })

    }

    const options = getOptions()
    const client = clients && Object.values(clients).filter(client => client['clientId'] === value)[0]
    return (
        <Container error={error}>
            <PopOut trigger='leftClick' placement='bottom' element={options} onOpen={() => setOpen(true)} onClose={() => setOpen(false)}>
                <Wrapper ref={ref}>
                    <Column>
                        <Row>
                            <Label>Select account</Label>
                            {error && <Error>{error}</Error>}
                        </Row>
                        <Title>{client && client['clientTitle']}</Title>
                    </Column>
                    <FaAngleDown style={{color: 'var(--secondary-color)', fontSize: '1.2rem', fontWeight: 'bold', transform: open && 'scaleY(-1)'}}/>
                </Wrapper>
            </PopOut>
        </Container>
    )
}

export default AccountSelector